<!--<div  class="custom-toggle normal" [ngClass]="{'checked': Value===1, 'unchecked': Value===0}"  (click)="toggle();"></div>-->
<!--[ngClass]="(Value)?'custom-toggle normal checked':'custom-toggle unchecked'"-->

<div class="custom-toggle normal" [ngClass]="{'checked': Value==1, 'unchecked': Value==0}" (click)="toggle()"></div>
